export var getCustomOperators = function () {
    return jQuery.fn.queryBuilder.constructor.DEFAULTS.operators.concat([
        { type: 'date_past', nb_inputs: 0, multiple: false, apply_to: ['string'] },
        { type: 'date_future', nb_inputs: 0, multiple: false, apply_to: ['string'] },
        { type: 'date_today', nb_inputs: 0, multiple: false, apply_to: ['string'] },
        { type: 'lt_days_ago', nb_inputs: 1, multiple: false, apply_to: ['number'] },
        { type: 'gt_days_ago', nb_inputs: 1, multiple: false, apply_to: ['number'] },
        { type: 'within_days', nb_inputs: 1, multiple: false, apply_to: ['number'] }
    ]);
};
